import React, { useEffect, useRef } from 'react'
import { useFormContext } from 'react-hook-form'
import ErrorMessage from './ErrorMessage'
import { formMessage } from './Message'
import StepQuestion from './StepQuestion'
import styled from 'styled-components'
import autoAnimate from '@formkit/auto-animate'
import ScoringSystem from './ScoringSystem'
import Radio from './Radio'
import parse from 'html-react-parser'
const WheelWrapper = styled.div`
    .wheel-bg-${(props) => (props.$subStep ? props.$subStep : 1)} {
        opacity: 1;
    }

    .wheel-text-${(props) => (props.$subStep ? props.$subStep : 1)} {
        opacity: 1;
    }
`

const NUMBER_OF_SCALES = 5

const StepTwo = ({ question, name, substeps, subStep, statistic }) => {
    console.log('statistic', statistic)
    const parent = useRef(null)
    useEffect(() => {
        parent.current && autoAnimate(parent.current)
    }, [parent])
    return (
        <div className="mt-14" ref={parent}>
            {substeps?.map((substep, index) => {
                const isActive = subStep === index + 1
                return isActive ? (
                    <SubStep
                        parentName={name}
                        isActive={isActive}
                        {...substep}
                        key={index}
                        statistic={statistic}
                        step={`${subStep} of ${substeps?.length}`}
                    />
                ) : null
            })}
        </div>
    )
}

const SubStep = ({ name, parentName, title, questions, description, step , statistic}) => {
    const stepName = `${parentName}.${name}`

    const {
        formState: { errors }
    } = useFormContext()

    return (
        <div>
            <legend className="mb-1 flex flex-col lg:flex-row w-full justify-between">
                <div className="flex flex-col lg:min-w-[400px] xl:min-w-[500px]">
                    <span className="font-grotesk-medium text-xl text-vivid_raspberry">
                        NIST Framework {step}
                    </span>
                    <p className="mt-1 font-grotesk-bold text-2xl text-dark_purple">
                        {title}
                    </p>
                </div>
                <div className="w-[110%] -ml-4 md:ml-0 mt-6 lg:mt-0 md:w-full justify-between flex">
                    <span className="lg:w-32 whitespace-pre-wrap text-center font-grotesk-medium text-sm lg:text-xl text-black">{statistic?.notImplemented && parse(statistic?.notImplemented)}</span>
                    <span className="lg:w-32 whitespace-pre-wrap text-center font-grotesk-medium text-sm lg:text-xl text-black">{statistic?.inComplete && parse(statistic?.inComplete)}</span>
                    <span className="lg:w-32 whitespace-pre-wrap text-center font-grotesk-medium text-sm lg:text-xl text-black">{statistic?.partiallyExists && parse(statistic?.partiallyExists)}</span>
                    <span className="lg:w-32 whitespace-pre-wrap text-center font-grotesk-medium text-sm lg:text-xl text-black">{statistic?.fullyDeployed && parse(statistic?.fullyDeployed)}</span>
                    <span className="lg:w-32 whitespace-pre-wrap text-center font-grotesk-medium text-sm lg:text-xl text-black">{statistic?.fullyDeployedOptimised && parse(statistic?.fullyDeployedOptimised)}</span>
                </div>
            </legend>
            {/* <p className="mb-8 italic text-han_purple/70">* {description}</p> */}
            <div className="space-y-10">
                {questions?.map((question, questionIndex) => {
                    const questionKey = `question-${questionIndex + 1}`
                    const errorMessage =
                        errors?.[parentName]?.[name]?.[questionKey]?.message || ""
                    return (
                        <div
                            className=" pb-6 lg:pb-0 lg:mt-10 border-t-[1px] border-[#D0D5DD]"
                            key={questionIndex}
                        >
                            <ErrorMessage message={errorMessage} />
                            <div className="mx-auto flex flex-col flex-wrap items-center justify-between pt-6 lg:flex-row lg:flex-nowrap">
                                <h3 className="max-w-[380px] lg:mr-8 xl:mr-0 xl:max-w-[410px] font-grotesk-light text-xl mb-6 lg:mb-0">
                                    {question}
                                </h3>
                                <div className="flex w-full justify-between lg:justify-end xl:justify-between xl:pr-2 xl:w-[calc(100%-500px)]">
                                    {Array?.from(
                                        { length: NUMBER_OF_SCALES },
                                        (_, index) => {
                                            const value = index + 1

                                            const questionName =
                                                stepName +
                                                '.question-' +
                                                (questionIndex + 1)

                                            const name =
                                                questionName + '-' + value

                                            return (
                                                <RadioNumber
                                                    questionName={questionName}
                                                    name={name}
                                                    value={value}
                                                    key={index}
                                                />
                                            )
                                        }
                                    )}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

const RadioNumber = ({ value, name, questionName }) => {
    const { register } = useFormContext()
    return (
        <div className="group flex w-28 xl:w-32 justify-center">
            <input
                id={name}
                {...register(questionName, {
                    required: formMessage.required
                })}
                type="radio"
                className="sr-only"
                value={value}
            />
            <label
                className="relative flex cursor-pointer items-center justify-center w-9 h-9"
                htmlFor={name}
            >
                <span className="group absolute left-0 top-2 aspect-square w-5 translate-x-1 rounded-full bg-transparent outline outline-2 outline-offset-4 outline-vivid_raspberry group-has-[input:checked]:bg-vivid_raspberry lg:w-[26px] lg:outline-[4px]"></span>
            </label>
        </div>
    )
}



export default StepTwo
